import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TReportingPeriodItem {
  id: number;
  name: string;
}

export interface IReportingPeriodItem extends TReportingPeriodItem {}

const ReportingPeriodItem = Model(
  (model: TReportingPeriodItem): IReportingPeriodItem => {
    const _reportingPeriodItem: TReportingPeriodItem = Object.assign({}, model);

    let create = (
      reportingPeriodItem: IReportingPeriodItem
    ): IReportingPeriodItem => {
      let obj = ValidatableObject(reportingPeriodItem);
      return obj;
    };

    let reportingPeriodItem = {
      get id() {
        return _reportingPeriodItem.id;
      },
      set id(value) {
        _reportingPeriodItem.id = value;
      },
      get name() {
        return _reportingPeriodItem.name;
      },
      set name(value) {
        _reportingPeriodItem.name = value;
      }
    };

    return create(reportingPeriodItem);
  }
);

export default ReportingPeriodItem;
